import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  playerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.palette.text.primary,
    minWidth: '120px',
    paddingTop: theme.spacing(3),
    '& img': {
      width: '153px',
    },
    [theme.breakpoints.down('sm')]: {
      '& img': {
        width: '100px',
      },
      '& h6': {
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
  },
}))

export default useStyles
